import React from 'react';
import styles from 'common/_Buttons/_GreenButtons/GreenButtons.module.css';
import { DefaultButton } from 'common/_Buttons/_DefaultButton/DefaultButton';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const GreenButton = Component => ({ ...props }) => {
    return <Component {...props} className={cx(styles.greenButton, props.className)}/>
};

export default GreenButton(DefaultButton);
